// const API_BASE_URL = "http://localhost:5000";
const API_BASE_URL = "http://82.29.160.72:5000";
export default API_BASE_URL;
